import { useEffect } from 'react';

import { useAppSelector } from '@/shared/hooks';

import {
  selectIsProcessing,
  selectIsRecording,
} from '../model/transcriptorSlice.selectors';

export const useRecordingBeforeUnload = () => {
  const isRecording = useAppSelector(selectIsRecording);
  const isProcessing = useAppSelector(selectIsProcessing);

  useEffect(() => {
    if (!isRecording && !isProcessing) {
      return;
    }

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload, {
      capture: true,
    });

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload, {
        capture: true,
      });
    };
  }, [isRecording, isProcessing]);
};
